﻿import { nsData } from "@/ServerTypes/Namespaces";
import { DataReportsService } from "@/ServerTypes/Data/DataReportsService";
import { IReadOnly, PropertyItem, Widget } from "@serenity-is/corelib";
import { DataReportViewGrid } from "./DataReportViewGrid";

export interface DataReportViewerOptions {
    reportKey: string;
    hideTitle?: boolean;
    hideToolbar?: boolean;
    hideExcelExport?: boolean;
    hideColumnPicker?: boolean;
    hidePager?: boolean;
    hideParams?: boolean;
    hideGrouping?: boolean;
    hideFooter?: boolean;
    autoRun?: boolean;
    processParams?: (params: PropertyItem[], paramValues: Record<string, string>, then: ((params: PropertyItem[]) => void)) => void;
}

export class DataReportViewer extends Widget<DataReportViewerOptions> implements IReadOnly {
    static override[Symbol.typeInfo] = this.registerEditor(nsData, [IReadOnly]);

    static override createDefaultElement() { return document.createElement("div"); }

    private viewGrid: DataReportViewGrid;

    constructor(props: { element?: any } & DataReportViewerOptions) {
        super(props);

        DataReportsService.GetViewerModel({
            EntityId: this.options.reportKey
        },
            response => {
                if (!response.Entity)
                    return;

                var model = response.Entity;
                const paramValues = {};

                var createGrid = () => {

                    var grid = this.viewGrid = new DataReportViewGrid({
                        element: this.element,
                        title: model.Title,
                        description: model.Description,
                        reportKey: model.ReportKey,
                        columns: model.Columns,
                        frozenColumns: model.FrozenColumns,
                        expandAllGroups: model.ExpandAllGroups,
                        queryType: model.QueryType,
                        params: model.Parameters,
                        paramValues: paramValues,
                        hidePager: this.options.hidePager,
                        hideGrouping: this.options.hideGrouping,
                        hideFooter: this.options.hideFooter,
                        enableParamPersistence: false
                    });

                    if (this.options.hideTitle) {
                        grid.element.findFirst('.grid-title, .report-description').hide();
                        grid["toolbar"].element.style(s => s.marginTop = "0");
                    }

                    if (this.options.hideExcelExport)
                        grid["toolbar"].findButton('export-xlsx-button').hide();

                    if (this.options.hideColumnPicker)
                        grid["toolbar"].findButton('column-picker-button').hide();

                    if (this.options.hideToolbar)
                        grid["toolbar"].element.hide();

                    if (this.options.hideParams ?? true)
                        grid.element.findFirst('.params-form').hide();

                    if (this.options.autoRun ?? true) {
                        grid.element.findFirst('.tool-button.execute-button').hide().each(x => x.click());
                    }
                };

                if (this.options.processParams)
                    this.options.processParams(model.Parameters, paramValues, params => {
                        model.Parameters = params;
                        createGrid()
                    });
                else
                    createGrid();

            });
    }

    get_readOnly(): boolean {
        return false;
    }

    set_readOnly(value: boolean): void {
    }
}

